import { SearchState, updatePage } from '@/reducers/search';
import { ListingQuery } from '@/shared/routes';
import { ListingHelper } from '@/tools/search/ListingHelper';

export const updatePageNumber = (
  query: ListingQuery,
  Helper: ListingHelper,
  search: SearchState
): void => {
  const page = isNaN(Number(query.o)) ? 1 : Number(query.o);
  Helper.checkThenDispatch(search.page !== page, updatePage(page));
};
